/** Where the score lives. Emails, redirects and links read these. */
export const READINESS_PUBLIC_PATH = "/6-figure-readiness-score";
export const READINESS_PAGE_PATH = "/my-coaching/business/readiness-score";

/**
 * The email the strategy call falls back to, for coaches at or past $60K. The
 * in-app score page opens the admin's Book-a-call link instead once one is
 * set. The public results page always uses the email: only a signed-in coach
 * can read the link.
 */
export const STRATEGY_CALL_URL =
  "mailto:support@dreamcoachmatch.com?subject=Strategy%20call";
